import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';

@Component({
    selector: 'app-dialog-contract-requested-offer-component',
    templateUrl: './dialog-contract-requested-offer.component.html',
    styleUrls: ['./dialog-contract-requested-offer.component.scss']
})
export class DialogContractRequestedOfferComponent implements OnInit {
    public createContractRequestForm: UntypedFormGroup;
    public notes: string = '';
    maxCharCount: number = 800;
    charCount: number = 800;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<DialogContractRequestedOfferComponent>
    ) {}

    ngOnInit(): void {
        const separator = '-'.repeat(25);
        let notesInitial = '';
        if (this.data.shiftDetails) {
            notesInitial += `${separator}\n`;
            notesInitial += 'Shift Details:\n';
            notesInitial += `${this.data.shiftDetails}\n`;
        }
        const params: any = {
            notes: new UntypedFormControl(notesInitial, [Validators.required, Validators.maxLength(this.maxCharCount)])
        };
        this.createContractRequestForm = new UntypedFormGroup(params);

        this.charCount = this.maxCharCount - notesInitial.length;
    }

    public send() {
        if (!this.createContractRequestForm.valid) {
            return;
        }

        const result = {
            send: true,
            requestStr: this.createContractRequestForm.get('notes').value
        };
        this.dialogRef.close(result);
    }

    public close() {
        const result = {
            send: false
        };
        this.dialogRef.close(result);
    }

    public hasError = (controlName: string, errorName: string) => {
        return this.createContractRequestForm.controls[controlName].hasError(errorName);
    };

    onKeyUp(note: HTMLTextAreaElement) {
        const length = note.value.length;
        this.charCount = this.maxCharCount - length;
    }
}
